import { colors } from "theme";

export const typography = {
  fontFamily: "Inter, sans-serif",
};

export const muiFieldStyles = {
  input: {
    "& .MuiInputBase-root": {
      marginTop: 0,
      fontWeight: 400,
      color: colors.softBlack,
    },
    "& .MuiInputBase-input": {
      fontSize: 14,
      paddingTop: 3,
      height: 19,
      color: colors.softBlack,
      WebkitTextFillColor: colors.softBlack,
      fontFamily: typography.fontFamily,
    },
    "& .MuiInputBase-input.Mui-disabled": {
      opacity: 0.5,
      color: colors.softBlack,
      WebkitTextFillColor: colors.softBlack,
    },
    "& .MuiInputBase-inputMultiline": {
      height: "auto",
    },
  },

  underline: {
    "& .MuiInput-underline:before": {
      borderBottomColor: colors.gray[300],
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: colors.gray[300],
    },
    "& .MuiInput-underline.Mui-focused:after": {
      borderBottomColor: colors.purple[700],
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):not(.Mui-focused):not(.Mui-error):before":
      {
        borderBottomColor: colors.gray[300],
      },
    "& .MuiInput-underline.Mui-error:after": {
      borderBottomColor: colors.red[500],
    },
    "& .MuiInput-underline.Mui-error:hover:not(.Mui-disabled):not(.Mui-focused):after":
      {
        borderBottomColor: colors.red[500],
      },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottomColor: colors.gray[300],
    },
  },

  label: {
    "& .MuiInputLabel-root": {
      fontSize: 14,
      color: colors.softBlack,
      fontFamily: typography.fontFamily,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: colors.purple[700],
    },
    "& .MuiInputLabel-root.Mui-disabled": {
      color: colors.softBlack,
    },
    "& .MuiInputLabel-shrink": {
      fontSize: 16,
      fontFamily: typography.fontFamily,
    },
  },

  helperText: {
    "& .MuiFormHelperText-root": {
      fontWeight: 300,
      minHeight: 19.2,
      marginLeft: 0,
      fontFamily: typography.fontFamily,
    },
  },

  menuItem: {
    fontSize: 14,
    fontFamily: typography.fontFamily,
  },

  select: {
    "& .MuiSelect-select": {
      fontSize: 14,
      fontFamily: typography.fontFamily,
    },
  },

  inputAdornment: {
    "& .MuiInputAdornment-positionStart": {
      marginRight: 0,
    },
  },

  formControl: {
    "& .MuiFormControl-root": {
      marginTop: 8,
      marginBottom: 4,
    },
  },

  formControlLabel: {
    root: {
      height: 32,
      overflowY: "visible",
      fontFamily: typography.fontFamily,
    },
    label: {
      fontSize: "14px",
      color: colors.softBlack,
      fontFamily: typography.fontFamily,
    },
  },

  checkBox: {
    "&.Mui-checked": {
      color: colors.purple[500],
    },
  },

  primaryButton: {
    backgroundColor: colors.purple[700],
    color: colors.white,
    textTransform: "unset",
    borderRadius: 999,
    "&:hover": {
      backgroundColor: colors.purple[900],
    },
  },
};

export const getStandardTextFieldSx = (hasError = false) => ({
  ...muiFieldStyles.input,
  ...muiFieldStyles.underline,
  ...muiFieldStyles.label,
  ...muiFieldStyles.helperText,
  ...muiFieldStyles.inputAdornment,
  ...(hasError
    ? {
        "& .MuiInput-underline:before": {
          borderBottomColor: colors.red[500],
        },
        "& .MuiInput-underline:after": {
          borderBottomColor: colors.red[500],
        },
        "& .MuiInput-underline.Mui-focused:after": {
          borderBottomColor: colors.red[500],
        },
        "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
          borderBottomColor: colors.red[500],
        },
        "& .MuiInputLabel-root": {
          color: colors.red[500],
        },
        "& .MuiInputLabel-root.Mui-focused": {
          color: colors.red[500],
        },
        "& .MuiInputLabel-root.Mui-error": {
          color: colors.red[500],
        },
      }
    : {}),
});
